import React, { memo, useEffect, useState } from 'react';
import {
  styled,
  Tooltip as MUITooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';
import { useGetResponsive } from '@stack/helpers/lib/responsive';

import BrandGroupListProps from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
const TooltipView: React.FC<BrandGroupListProps> = (props) => {
  const { children, title, ...tooltipProps } = props;

  // ========================= HOOKS
  const { lg: isMobileView } = useGetResponsive();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  // ========================= EVENTS
  const onClickTooltip = (event: { stopPropagation: () => void }) => {
    if (isMobileView) {
      event.stopPropagation();
      setTooltipOpen((prev) => !prev);
    }
  };

  // ========================= EFFECTS
  useEffect(() => {
    const onWindowClick = () => {
      if (tooltipOpen) {
        setTooltipOpen(false);
      }
    };

    if (tooltipOpen) {
      window.addEventListener('click', onWindowClick);
    }

    return () => {
      window.removeEventListener('click', onWindowClick);
    };
  }, [tooltipOpen]);

  // ========================= VIEWS
  const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
    <MUITooltip
      {...props}
      classes={{ popper: className }}
      placement="right"
      arrow
    />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: isMobileView ? 150 : 200,
    },
  });

  return (
    <CustomWidthTooltip
      {...tooltipProps}
      title={title}
      open={isMobileView ? tooltipOpen : undefined}
      onClick={onClickTooltip}
    >
      {children}
    </CustomWidthTooltip>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export const Tooltip = memo(TooltipView);
export default Tooltip;
